// extracted by mini-css-extract-plugin
module.exports = {"container":"_3_roAbLQGAn0Qr7SnD6mAl","label":"KzGNb6mT3zF-MEyuRuH17","icon":"_1fL-e9scbqpHcB7d6ih31g"};